/*************************************************/
/* HEADER                                        */
/*************************************************/

export function header($body) {
    let $header;
    let menuNavParent = $(".menu-nav__item--parent");
    const megaMenuOpenClass = "open";
    var bannerVideoResizeTimer;
    const maxS = 666;


    const init = function () {
        $header = $(".header");

        $(window).on("scroll", function () {
            closeMegaMenu();
        });

        // Sticky header
        setStickyHeader();
        $(window).scroll(function () {
            setStickyHeader();
        });


        menuNavParent.click(function (e) {
            e.stopPropagation();
            if (!$(this).hasClass(megaMenuOpenClass)) {
                closeMegaMenu();
                $(this).addClass(megaMenuOpenClass);
                $header.addClass(megaMenuOpenClass);
            } else {
                $(this).removeClass(megaMenuOpenClass);
                $header.removeClass(megaMenuOpenClass);

            }
        });

        menuNavParent.find(".mega-menu").click(function (e) {
            e.stopPropagation();
        });
        $body.click(function () {
            closeMegaMenu();
        });

        //Resize listener for the banner
        $(window).on("resize", function () {
            clearTimeout(bannerVideoResizeTimer);
            bannerVideoResizeTimer = setTimeout(function () {
                playBannerVideo();
            }, 100);
        });
        playBannerVideo();

    };

    init();

    function playBannerVideo() {
        var bannerVideo = $('#bannerVideo');
        if (bannerVideo.length) { //Only run if there actually is a banner
            const screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            if (screenWidth > maxS) {
                // Play video
                bannerVideo[0].play();
            }
        }
    }

    function closeMegaMenu() {
        menuNavParent.removeClass(megaMenuOpenClass);
        $header.removeClass(megaMenuOpenClass);
    }

    function setStickyHeader() {
        if ($(window).scrollTop() > $header.height() / 2) {
            $body.addClass("header-sticky");
        } else {
            $body.removeClass("header-sticky");
        }
    }
}

